import {
  AdcampaignPlaybackReportType,
  AdcampaignPlaybackReportTypeForInput,
  PlaybackReportType,
} from '@shared/api/graphql/generated';
import { TEXTS } from './texts';

export enum ReportTypes {
  AudioAds = 'AudioAds',
  VideoAds = 'VideoAds',
  VideoStreams = 'VideoStreams',
}

export const ReportTabs = {
  ...PlaybackReportType,
  ...ReportTypes,
} as const;

export const SWITCH_REPORT_MODE_TABS = {
  [ReportTabs.AudioAds]: TEXTS.TAB_AUDIO,
  [ReportTabs.VideoAds]: TEXTS.TAB_VIDEO,
  [ReportTabs.VideoStreams]: TEXTS.TAB_VIDEO_STREAMS,
};

export const TabsToReportTypeMap = {
  [ReportTabs.AudioAds]: [AdcampaignPlaybackReportType.AudioAds, AdcampaignPlaybackReportType.Undefined],
  [ReportTabs.VideoAds]: [AdcampaignPlaybackReportType.VideoAds],
  [ReportTabs.VideoStreams]: [AdcampaignPlaybackReportType.VideoWaves],
  [ReportTabs.Music]: undefined,
  [ReportTabs.AdCampaign]: undefined,
};

export const MapPlaybackReportTypeByTab = {
  [ReportTabs.AudioAds]: PlaybackReportType.AdCampaign,
  [ReportTabs.VideoAds]: PlaybackReportType.AdCampaign,
  [ReportTabs.VideoStreams]: PlaybackReportType.AdCampaign,
  [ReportTabs.Music]: PlaybackReportType.Music,
  [ReportTabs.AdCampaign]: PlaybackReportType.AdCampaign,
};

export const AdcampaignReportTypeByTab = {
  [ReportTabs.AudioAds]: AdcampaignPlaybackReportTypeForInput.AudioAds,
  [ReportTabs.VideoAds]: AdcampaignPlaybackReportTypeForInput.VideoAds,
  [ReportTabs.VideoStreams]: AdcampaignPlaybackReportTypeForInput.VideoWaves,
  [ReportTabs.Music]: AdcampaignPlaybackReportTypeForInput.AudioAds,
  [ReportTabs.AdCampaign]: AdcampaignPlaybackReportTypeForInput.AudioAds,
};
